import script from "./RepeaterRow.vue?vue&type=script&setup=true&lang=js"
export * from "./RepeaterRow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"RepeaterRow.vue"]])

export default __exports__